import { Body, IconButton } from '@assembly-js/design-system';
import copy from 'clipboard-copy';
import React from 'react';

import { notify } from 'src/clients/ApiService';
import { useAppDispatch } from 'src/hooks/useStore';
import { UrlUtils } from 'src/utils';

interface Props {
  portalDomainUrl: string;
  showCopyIcon: boolean;
}

export const BillingPreviewDomainHeader: React.FC<Props> = ({
  portalDomainUrl,
  showCopyIcon,
}) => {
  const dispatch = useAppDispatch();
  const portalUrl = UrlUtils.GetFullUrl(portalDomainUrl);

  const handleCopy = () => {
    copy(portalUrl)
      .then(() => {
        notify({
          status: 'success',
          successMessage: 'Copied to clipboard',
          dispatch,
        });
      })
      .catch((error) => {
        console.error('Failed to copy:', error);
        notify({
          status: 'error',
          errorMessage: 'Failed to copy link',
          dispatch,
        });
      });
  };
  return (
    <div className="bg-[#FCFEFF] rounded-t-lg">
      <div className="py-1 ml-0 @2xl:mx-5 flex items-center justify-center ">
        <div className="hidden @2xl:flex items-center gap-2 ">
          <div className="bg-[#EDF2F6] rounded-full w-3 h-3" />
          <div className="bg-[#EDF2F6] rounded-full w-3 h-3" />
          <div className="bg-[#EDF2F6] rounded-full w-3 h-3" />
        </div>
        <div className="flex justify-center w-full items-center @container">
          <div className="bg-[#F6F9FC] mx-3 @2xl:mx-0 h-6 w-full @xl:w-[400px] flex items-center justify-between px-2 rounded-md">
            <div className="flex items-center justify-center gap-0.5 flex-grow">
              {showCopyIcon && (
                <IconButton
                  icon="Copy"
                  className="p-0 w-5 h-5 [&>svg]:w-3 [&>svg]:h-3 text-black-heading"
                  onClick={handleCopy}
                  variant="minimal"
                />
              )}
              <Body size="xs">{portalDomainUrl}</Body>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
